// @flow
import React, { Component } from "react";
import withStyles from "elevate-ui/withStyles";
import classNames from "classnames";
import KeyboardArrowDown from "elevate-ui-icons/KeyboardArrowDown";
import KeyboardArrowUp from "elevate-ui-icons/KeyboardArrowUp";
import ButtonGroup from "elevate-ui/ButtonGroup";
import { FastField } from "formik";
import enhanceWithClickOutside from "react-click-outside";

import Dropdown from "./Dropdown";

type $Props = {
  className?: string,
  classes: Object,
  values: Object,
  mlsApiVersion: number,
};

type $State = {
  isOpen: boolean,
};

class Bedrooms extends Component<$Props, $State> {
  fastFieldId = "minBeds";
  fastFieldName = "minBeds";

  constructor(props) {
    super(props);

    if (this.props.mlsApiVersion === 2) {
      this.fastFieldId = "bedroomsTotal";
      this.fastFieldName = "pmin_bedroomsTotal";
    }

    this.state = {
      isOpen: false,
    };
  }

  toggleDropdown = () => {
    this.setState((state) => ({ isOpen: !state.isOpen }));
  };

  handleClickOutside() {
    if (this.state.isOpen) {
      this.setState({ isOpen: false });
    }
  }

  renderDisplayText = (values: Object) => {
    if (this.props.mlsApiVersion === 2) {
      if (values.pmin_bedroomsTotal) {
        return `${values.pmin_bedroomsTotal}+ Beds`;
      } else {
        return "All Bedrooms";
      }
    }

    if (values.minBeds) {
      return `${values.minBeds}+ Beds`;
    } else {
      return "All Bedrooms";
    }
  };

  render() {
    const { className, classes, values } = this.props;
    const { isOpen } = this.state;

    return (
      <div className={classes.container}>
        <div
          className={classNames(classes.root, className)}
          onClick={this.toggleDropdown}
        >
          {this.renderDisplayText(values)}{" "}
          {this.state.isOpen ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
        </div>
        <Dropdown isOpen={isOpen}>
          <FastField
            id={this.fastFieldId}
            name={this.fastFieldName}
            label="Bedrooms"
            component={ButtonGroup}
            items={[
              { label: "1+", value: "1" },
              { label: "2+", value: "2" },
              { label: "3+", value: "3" },
              { label: "4+", value: "4" },
              { label: "5+", value: "5" },
              { label: "6+", value: "6" },
            ]}
          />
        </Dropdown>
      </div>
    );
  }
}

const styles = (theme) => ({
  root: {
    display: "flex",
    flexRow: "row nowrap",
    justifyContent: "space-between",
    alignItems: "center",
    position: "relative",
    width: 200,
    height: 48,
    margin: "8px auto 16px",
    padding: "8px 12px",
    color: theme.typography.bodyColor,
    fontFamily: "inherit",
    fontWeight: "400",
    fontSize: "16px",
    lineHeight: "20px",
    backgroundColor: "#fff",
    border: theme.borders["default"],
    borderRadius: theme.globalBorderRadius,
    cursor: "default",
  },
  container: {
    position: "relative",
  },
});

export default withStyles(styles, { name: "Bedrooms" })(
  enhanceWithClickOutside(Bedrooms)
);
